import { Button, SecondaryButton, OutlineButton, ReverseButton } from '@chegg-ui/button';
import styled from 'styled-components';
export var RestyledBaseButton = styled(Button).withConfig({
  componentId: "lkithz-0"
})(["text-decoration:none;-webkit-appearance:none;"]);
export var RestyledSecondaryButton = styled(SecondaryButton).withConfig({
  componentId: "lkithz-1"
})(["text-decoration:none;-webkit-appearance:none;"]);
export var RestyledOutlineButton = styled(OutlineButton).withConfig({
  componentId: "lkithz-2"
})(["text-decoration:none;-webkit-appearance:none;"]);
export var RestyledReverseButton = styled(ReverseButton).withConfig({
  componentId: "lkithz-3"
})(["text-decoration:none;-webkit-appearance:none;"]);